import * as XLSX from "xlsx";

import { OperationResult, SpreadsheetRow } from "./types";

/**
 * Parses an Excel file into raw JSON data
 *
 * @param file - The Excel file to parse
 * @returns ValidationResult containing the parsed rows or error message
 */
export async function loadExcelFile(
    file: File
): Promise<OperationResult<SpreadsheetRow[]>> {
    try {
        const arrayBuffer = await file.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer);
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        return {
            success: true,
            data: XLSX.utils.sheet_to_json(worksheet, {
                raw: false,
                defval: "",
            }),
        };
    } catch (error) {
        return {
            success: false,
            errors: [
                error instanceof Error
                    ? error.message
                    : "Error parsing spreadsheet",
            ],
        };
    }
}
